import React from "react";
import { NavDropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const Notification = ({
  id,
  title,
  body,
  timestamp,
  read,
  handleRead,
  link,
}) => {
  const history = useHistory();
  const handleClick = () => {
    if (read) handleRead({ read, ID: id });
    if (!link) return;
    history.push(link);
  };

  const readHandler = (e) => {
    e.stopPropagation();
    handleRead({ read, ID: id });
  };

  return (
    <React.Fragment>
      <NavDropdown.Item
        className="py-1 px-2"
        style={{
          minWidth: "15rem",
          backgroundColor: !read && "#F1FFF1",
        }}
        onClick={handleClick}
      >
        <p className="h6" style={{ margin: 0 }}>
          {title}
        </p>
        <small className="text-wrap">{body}</small>
        <br />
        <div className="d-flex justify-content-between">
          <small className="text-muted">{timestamp}</small>
          <i
            className={
              !read
                ? "fas fa-circle text-info fa-xs"
                : "far fa-circle text-info fa-xs"
            }
            onClick={(e) => readHandler(e)}
          ></i>
        </div>
      </NavDropdown.Item>
      <NavDropdown.Divider className="m-0" />
    </React.Fragment>
  );
};

export default Notification;
